import React from 'react';
import { bindNumbersToWords, splitLabelSegments } from '../../utils/labelDisplayUtils';

type LabelSegmentsProps = {
  label: string;
  segmentClassName: string;
  separatorClassName?: string;
};

const LabelSegments: React.FC<LabelSegmentsProps> = ({
  label,
  segmentClassName,
  separatorClassName,
}) => {
  const segments = splitLabelSegments(label);

  if (segments.length <= 1) {
    return (
      <span className={segmentClassName}>
        {bindNumbersToWords(label)}
      </span>
    );
  }

  return (
    <>
      {segments.map((segment, index) => (
        <React.Fragment key={`${segment}-${index}`}>
          {index > 0 && (
            <span className={separatorClassName}> / </span>
          )}
          <span className={segmentClassName}>{bindNumbersToWords(segment)}</span>
        </React.Fragment>
      ))}
    </>
  );
};

export default LabelSegments;
